export default __webpack_public_path__ + "0248f6d2d5415b1b62d04c57a3de4f9924ab6676/161a231856ba99f96b16b1f91115e718.png";